import { render, staticRenderFns } from "./order_morepay.vue?vue&type=template&id=648273e2&scoped=true&"
import script from "./order_morepay.vue?vue&type=script&lang=js&"
export * from "./order_morepay.vue?vue&type=script&lang=js&"
import style0 from "./order_morepay.vue?vue&type=style&index=0&id=648273e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648273e2",
  null
  
)

export default component.exports